import { useState, useEffect } from "react";

import { loadMaterialShadeList } from "../services/materialCategory";

const useMaterialShades = (editID) => {

    const [materialShade, setMaterialShade] = useState([]);
    const [selectedShade, setSelectedShade] = useState(null);
    const [selectedShadeID, setSelectedShadeID] = useState(null);
    const [isMaterialShadeDataLoaded, setIsMaterialShadeDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialShade = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadMaterialShadeList(para);
            if (data && data.length > 0) {
                setMaterialShade(data);

                if (selectedID === 0) {
                    setSelectedShade([]);
                    setSelectedShadeID([]);
                    setIsMaterialShadeDataLoaded(true);
                }
                else {
                    const initialMaterialCategory = data.find((dept) => dept.id_material_shade === selectedID);
                    // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                    if (initialMaterialCategory) { // ✅ Corrected check
                        setSelectedShade(initialMaterialCategory);
                        setSelectedShadeID(initialMaterialCategory.id_material_shade);
                        setIsMaterialShadeDataLoaded(true);
                    }

                }


            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialShadeDataLoaded && editID === 0) {
            fetchMaterialShade();
        }
    }, [isMaterialShadeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMaterialShadeByID = async (selectedID) => {
        await fetchMaterialShade(selectedID);
    };

    return {
        materialShade,
        selectedShade,
        selectedShadeID,
        setSelectedShade,
        setSelectedShadeID,
        loadMaterialShadeByID,
    };
};

export default useMaterialShades;
